import http from '@/utils/request'

// 授权 code 与短信 code 共用接口；登录请求不附带旧身份。
const loginOptions = { withToken: false }

// 用户手动输入的微信 code 交给后端换取 openId，并判断是否已绑定手机号。
export function loginByCode(code) {
  return http.post('/login/parent', { uuid: '', username: '', code }, loginOptions)
}

// 短信发送只传手机号，openId 在绑定登录时再作为 uuid 传入。
export function sendParentVerifyCode(username) {
  return http.post('/login/verifyCode/parent', { username }, loginOptions)
}

// 此处 code 是短信验证码；绑定成功后接口直接返回 token。
export function loginByPhone({ uuid, username, code }) {
  return http.post('/login/parent', { uuid, username, code }, loginOptions)
}
